'use strict';

angular.module('internal.users')
    .controller('InternalUserServicesLongevities', ['$scope', 'ServiceUserLongevities', 'ServiceUserLongevityCredits', '$state', '$rootScope', function ($scope, ServiceUserLongevities, ServiceUserLongevityCredits, $state, $rootScope){
        $scope.resetUser();
        $scope.redeeming = false;
        $scope.showRedeem = false;
        $scope.isLongevitiesOpen = true;
        $scope.isLongevitiyCreditsOpen = true;

        $scope.instructions = $rootScope.enterprise.longevity_allow_multiple ? "" : "The system is configured to only count one longevity credit per year for each service affliation.";

        ServiceUserLongevities.get({ user_id: $scope.userID }).then(function (data) {
            $scope.service_user_longevities = data;
        })

        ServiceUserLongevityCredits.get({ user_id: $scope.userID }).then(function (data) {
            $scope.service_user_longevity_credits = data;
        })

        ServiceUserLongevities.getCount({ user_id: $scope.userID }).then(function (data) {
            if (data != null) {
                $scope.available_credits = data;
                if (data % 1 > 0) {
                    $scope.showRedeem = true;
                }
            }
            else {
                $scope.available_credits = '0.00';
            }
        })

        $scope.redeem = function () {
            $scope.redeeming = true;

            if (window.confirm('Are you sure you want to redeem these longevity credits?')) {
                ServiceUserLongevities.manualRedemption($scope.userID).then(function () {
                    $scope.redeeming = false;
                    ServiceUserLongevities.get({ user_id: $scope.userID }).then(function (data) {
                        $scope.service_user_longevities = data;
                    });

                    ServiceUserLongevityCredits.get({ user_id: $scope.userID }).then(function (data) {
                        $scope.service_user_longevity_credits = data;
                    });
                    $scope.available_credits = '0.00'
                    $scope.showRedeem = false;
                    $scope.resetUser();
                });

             }
            else {
                $scope.redeeming = false;
            }
        }

        $scope.link = {
            state: 'internal.licensing.user.services.longevity',
            params: [
                {
                    name: 'longevityID',
                    field: 'id'
                },
                {
                    name: 'longevity',
                    field: ''
                }
            ]
        };

        $scope.columns = [
            {
                label: 'Service',
                field: 'service_nameandnumber',
                type: 'text'
            },
            {
                label: 'Longevity Date',
                field: 'longevity_date',
                type: 'date'
            },
            
            {
                label: 'Credit Value',
                field: 'credit_value',
                type: 'decimal'
            },
            {
                label: 'Redeemed',
                field: 'redeemed',
                type: 'yesno'
            },
            {
                label: 'Approved By',
                field: 'approved_by',
                type: 'text'
            },
            {
                label: 'Approved On ',
                field: 'approved_on',
                type: 'datetime'
            }
        ]

        $scope.credit_columns = [
            {
                label: 'Total Redeemed Credits',
                field: 'total_credits',
                type: 'decimal'
            },
            {
                label: 'Redeemed By',
                field: 'createdby',
                type: 'text'
            },
            {
                label: 'Redeemed On ',
                field: 'createdon',
                type: 'datetime'
            },
            {
                label: 'Total $ Redeemed',
                field: 'total_redeemed',
                type: 'money'
            }
        ]
    }])
;